module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/hero_mobile-4968d9404cc83dc48d47a97ca2c7bb97.jpg";